import { white } from 'styles'

import { makeStyles } from '@mui/styles'

export default makeStyles({
  details: {
    '& .MuiAccordionDetails-root': {
      background: white,
    },
  },
})
